import { render, staticRenderFns } from "./mobileTab.vue?vue&type=template&id=285ba234"
import script from "./mobileTab.vue?vue&type=script&lang=js"
export * from "./mobileTab.vue?vue&type=script&lang=js"
import style0 from "./mobileTab.vue?vue&type=style&index=0&id=285ba234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports